<div class="page-header-row">
  <div class="breadcrumb-wrap">
    <ul class="breadcrumbs">
      <li class="breadcrumb">Galleries</li>
    </ul>
  </div>
  <div class="search-wrap">
    <!-- Search input -->
    <div class="tag-search-wrap">
      <div class="search-row">
        <input
          matInput
          type="search"
          [formControl]="searchText"
          placeholder="Search Gallery"
          name="searchGallery"
          (keyup)="onFilter_keyup($event)"
        />
        <div class="search-row-icon" (click)="clearSearch()" matTooltip="Clear Search">
          <i class="material-icons search-clear">close</i>
        </div>
      </div>
    </div>
  </div>
</div>

<app-galleries
  [galleries]="filteredGalleries"
  [offices]="officemodels"
  [userOfficeId]="userOfficeId"
  [showStatusFilter]="false"
  (selectGallery)="onGallerySelect($event)"
></app-galleries>
